<template>
	<div class="sa-page-dashboard">
		<div class="sa-page-dashboard-header">
			<b-row>
				<b-col v-for="headerElement in dashboard.headerElements" :key="headerElement.id" :cols="headerElement.cols" :xs="headerElement.xs" :sm="headerElement.sm" :md="headerElement.md" :lg="headerElement.lg" :xl="headerElement.xl">
					<!-- <b-overlay :show="headerElement.showOverlay" rounded="sm">
						<b-card class="sa-card sa-header-nowrap sa-info-card-dashboard" :header="headerElement.title" header-tag="header" footer-tag="footer" title="">
							<b-card-body>
								<b-card-text class="text-right sa-dashboard-data-text">{{ headerElement.value }}</b-card-text>
							</b-card-body>
						</b-card>
					</b-overlay> -->
					<data-analysis-dashboard-header-view-component :chartParams="headerElement" @updateChart="onUpdateChart"></data-analysis-dashboard-header-view-component>
				</b-col>
			</b-row>
		</div>
		<div class="sa-page-dashboard-body">
			<b-row>
				<b-col v-for="bodyElement in dashboard.bodyElements" :key="bodyElement.id" :cols="bodyElement.cols" :xs="bodyElement.xs" :sm="bodyElement.sm" :md="bodyElement.md" :lg="bodyElement.lg" :xl="bodyElement.xl">
					<data-analysis-chart-view-component :chartParams="bodyElement" @updateChart="onUpdateChart"></data-analysis-chart-view-component>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
//import axios from "axios";
import DataAnalysisChartViewComponent from "./DataAnalysisChartViewComponent.vue";
import DataAnalysisDashboardMixin from "../mixins/DataAnalysisDashboardMixin";
import DataAnalysisDashboardHeaderViewComponent from "./DataAnalysisDashboardHeaderViewComponent.vue";
export default {
	props: {
		idDashboard: String,
	},
	mixins: [DataAnalysisDashboardMixin],
	components: { DataAnalysisChartViewComponent, DataAnalysisDashboardHeaderViewComponent },
	created() {
		if (this.idDashboard) {
			this.id = this.idDashboard;
		} else {
			this.id = this.$route.params.id;
		}
	},
	data() {
		return {
			id: null,
			pathResource: "/dataanalysisdashboard",
			jsonData: { title: "", descrizione: "", dashboard: { headerElements: [], bodyElements: [] } },
			dashboard: { headerElements: [], bodyElements: [] },
		};
	},
	mounted() {
		let me = this;
		//me.id = this.$route.params.id;
		if (me.id !== "-1") {
			me.loadData(); //<- sta in DataAnalysisDashboardMixin
		} else {
			me.jsonData.dashboard = JSON.stringify(this.dashboard);
			this.$emit("updateDashBoard", me.jsonData);
		}
	},
	methods: {
		onUpdateChart() {},
	},
};
</script>

<style></style>
